import PropTypes from 'prop-types';
import React from 'react';

import cssColorFromArray from '~app/core/cssColorFromArray';

const GradientBackground = ({startColor, endColor, vertical = true, children}) => {
  return (
    <div className="GradientBackground"
      style={{
        "background": `linear-gradient(
          ${vertical ? "to bottom" : "to right"},
          ${cssColorFromArray(startColor)},
          ${cssColorFromArray(endColor)}
        )`,
      }}
    >
      {children}
    </div>
  );
};

GradientBackground.propTypes = {
  startColor: PropTypes.array,
  endColor: PropTypes.array,
};

export default GradientBackground;



// WEBPACK FOOTER //
// ./src/components/GradientBackground.js